import { ChangeEvent, FunctionComponent, useEffect, useState } from 'react'

import { MdPlayArrow, MdSearch } from 'react-icons/md'
import { Grid } from '@material-ui/core'

import Autocomplete from 'shared/components/Autocomplete'
import Scaffold from 'shared/components/ScaffoldNew'
import { colors } from 'shared/styles/colors'
import { registerEvent } from 'shared/services/TrackingGAService'
import { IFindCaminhaoByDescricao } from 'modules/caminhao/domain/usecases/FindCaminhaoByDescricao'
import { useCaminhao } from 'modules/caminhao/hooks/useCaminhao'
import { IFindAll } from 'modules/tipoCaminhao/domain/usecases/FindAll'
import { ITipoCaminhao } from 'modules/veiculos/domain/entities/Veiculo'

import { StyledInput, Label } from './styles'

type TProps = {
  findAll: IFindAll
  findCaminhaoByDescricao: IFindCaminhaoByDescricao
}

const TypeName: FunctionComponent<TProps> = ({
  findAll,
  findCaminhaoByDescricao,
}) => {
  const {
    tipoCaminhao,
    setTipoCaminhao,
    nomeCaminhao,
    setNomeCaminhao,
    handleNextButton,
    handleBackButton,
    loading,
    setLoading,
    setError,
    setErrorMessage,
  } = useCaminhao()

  const [tipoCaminhaoInput, setTipoCaminhaoInput] = useState('')
  const [tipoCaminhaoList, setTipoCaminhaoList] = useState<ITipoCaminhao[]>([])

  useEffect(() => {
    const init = async () => {
      setLoading(true)
      try {
        const response = await findAll.execute()
        setLoading(false)

        setTipoCaminhaoList(response)
      } catch (e) {
        setLoading(false)
      }
    }

    init()
  }, [])

  const handleTipoCaminhao = (tipoCaminhao: string) => {
    setTipoCaminhaoInput(tipoCaminhao)
  }

  const handleNextButtonFn = async () => {
    registerEvent({
      categoria: 'Cadastro de Caminhão',
      acao: 'Click Próximo',
      local: 'Passo de selecionar o tipo de caminhão',
    })

    setLoading(true)
    try {
      const response = await findCaminhaoByDescricao.execute({
        descricao: nomeCaminhao,
        page: 1,
        per_page: 15,
      })

      if (response.data.length) {
        setErrorMessage('Caminhao já cadastrado com esse nome')
        setError(true)
      } else {
        handleNextButton()
      }
      setLoading(false)
    } catch (e: unknown) {
      setLoading(false)
      if (e instanceof Error) {
        setErrorMessage(e.message)
      } else {
        setErrorMessage('Erro ao buscar caminhão pela descrição')
      }
      setError(true)
    }
  }

  return (
    <>
      <Scaffold
        onClickBackButton={handleBackButton}
        onClickNextButton={handleNextButtonFn}
        titleBackButton="Voltar"
        titleNextButton="Próximo"
        isNextButtonDisabled={!tipoCaminhao || !nomeCaminhao}
        showFooterScaffold
        icon={MdPlayArrow}
        color={tipoCaminhao && nomeCaminhao ? colors.green : colors.gray}
        title="Tipo de caminhão"
        titleHeader="Novo caminhão"
        loading={loading}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={3}>
            <Autocomplete
              label="Qual o tipo do caminhão?"
              placeholder="Por ex: Bitrem 2 eixosd"
              inputValue={tipoCaminhaoInput}
              onInputChange={(event, newInputValue) => {
                handleTipoCaminhao(newInputValue)
              }}
              onChange={(_event, newValue: ITipoCaminhao) => {
                setTipoCaminhao(newValue)
              }}
              options={tipoCaminhaoList}
              getOptionLabel={option => (option as ITipoCaminhao).descricao}
              loading={loading}
              popupIcon={MdSearch}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={9} />
          <Grid item xs={12} sm={12} md={3}>
            <>
              <Label>Qual o nome do caminhão?</Label>
              <StyledInput
                placeholder="Informe o nome"
                name="nomeCaminhao"
                type="text"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setNomeCaminhao(e?.target?.value)
                }}
              />
            </>
          </Grid>
        </Grid>
      </Scaffold>
    </>
  )
}

export default TypeName
